// Medición del outlet y de la oferta Quick-Step en GA4 (eventos de promoción recomendados por Google).
// - view_promotion: el bloque de ofertas de la home o la franja Quick-Step se ve en pantalla (una vez por página).
// - select_promotion: clic en una oferta o en «Ver todo el outlet» de la home, en «Ofertas» del menú, en un
//   producto de la página de Ofertas o en la franja Quick-Step. creative_slot dice desde dónde.
// Las vistas de producto, «añadir al carrito» y compras ya las manda la app de Google (nombres «Últimas…»).
// Usa el gtag que ya está en la página y respeta el consentimiento de cookies (modo de consentimiento de Google).
// Cada evento lleva UN artículo (lo visto o lo clicado): así GA4 rellena «creative slot» y cuenta vistas/clics
// (itemsViewedInPromotion / itemsClickedInPromotion) sin crear dimensiones personalizadas.
(() => {
  if (window.MPOutletTracking) return;
  window.MPOutletTracking = true;
  const OUTLET = { promotion_id: 'outlet', promotion_name: 'Outlet · Últimas unidades' };
  const QS = { promotion_id: 'rodapie-regalo-quick-step', promotion_name: 'Rodapié de regalo Quick-Step' };
  const send = (name, params) => { if (typeof window.gtag === 'function') window.gtag('event', name, params); };
  const text = el => (el?.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  const path = href => { try { return new URL(href, location.origin).pathname; } catch (e) { return ''; } };
  const onOutletPage = () => /^\/collections\/outlet\/?$/.test(location.pathname);

  const seen = new WeakSet();
  const observe = (selector, promo, slot, label) => {
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting || seen.has(entry.target)) return;
      seen.add(entry.target); io.unobserve(entry.target);
      send('view_promotion', { ...promo, creative_slot: slot, items: [{ item_id: slot, item_name: label }] });
    }), { threshold: 0.4 });
    document.querySelectorAll(selector).forEach(el => io.observe(el));
  };

  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const to = path(link.href);
    const home = link.closest('.mp-outlet');
    if (home) {
      const offer = link.closest('.mp-outlet__offer');
      send('select_promotion', { ...OUTLET, creative_slot: 'home-bloque', creative_name: offer ? 'oferta' : 'ver-todo',
        items: [{ item_id: 'home-bloque', item_name: offer ? text(offer.querySelector('.mp-outlet__name')) : 'Ver todo el outlet' }] });
      return;
    }
    if (link.closest('.mp-rq-strip')) {
      const name = to.startsWith('/pages/') ? 'como-funciona' : 'ver-laminados';
      send('select_promotion', { ...QS, creative_slot: 'home-franja', creative_name: name, items: [{ item_id: 'home-franja', item_name: name === 'como-funciona' ? 'Cómo funciona' : 'Ver laminados Quick-Step' }] });
      return;
    }
    if (/^\/collections\/outlet\/?$/.test(to)) {
      const slot = link.closest('header-sidebar, .header-sidebar, [id*="sidebar"], [class*="sidebar"], .drawer') ? 'menu-lateral'
        : link.closest('header, .header') ? 'menu' : link.closest('footer, .footer') ? 'pie' : 'otro';
      send('select_promotion', { ...OUTLET, creative_slot: slot, creative_name: text(link) || 'Ofertas', items: [{ item_id: slot, item_name: 'Ofertas (' + slot + ')' }] });
      return;
    }
    if (onOutletPage() && to.startsWith('/products/')) {
      const card = link.closest('product-card, .product-card');
      send('select_promotion', { ...OUTLET, creative_slot: 'pagina-ofertas', creative_name: 'producto',
        items: [{ item_id: 'pagina-ofertas', item_name: [...(card || link).querySelectorAll('a[href*="/products/"]')].map(text).find(Boolean) || text(link) || to }] });
    }
  }, true);

  const init = () => {
    observe('.mp-outlet', OUTLET, 'home-bloque', 'Bloque de ofertas (home)');
    observe('.mp-rq-strip', QS, 'home-franja', 'Franja Quick-Step (home)');
    if (onOutletPage()) send('view_promotion', { ...OUTLET, creative_slot: 'pagina-ofertas', items: [{ item_id: 'pagina-ofertas', item_name: 'Página de Ofertas' }] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
